import { backofficeRequest } from '../../../axios'

export default class UserApi {
  async getUsersByRole(role) {
    const res = await backofficeRequest.get(`/backoffice/users?role=${role}`)
    return res.data
  }
}
